<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 16:15:38
 * @LastEditTime: 2020-06-20 14:26:18
 * @Description: 添加题目步骤操作栏
 -->
<template>
  <div class="add-question-action-bar">
    <pss-button text="返回" @on-click="clickCanelBtnHandler" />
    <pss-button v-if="prevBtnShow" text="上一步" @on-click="clickPrevBtnHandler" />
    <pss-button v-if="nextBtnShow" text="下一步" @on-click="clickNextBtnHandler" />
    <pss-button
      v-if="doneBtnShow" :disabled="!doneBtnEnable" text="完成"  @on-click="clickDoneBtnHandler" />
  </div>
</template>

<script>
export default {
  name: 'AddQuestionActionBar',
  props: {
    current: { type: Number, required: true },
    steps: { type: Number, required: true },
    doneBtnEnable: { type: Boolean, required: true },
    type: { type: String, required: true },
  },
  computed: {
    prevBtnShow() {
      return this.current > 0 && this.current < this.steps;
    },
    nextBtnShow() {
      return this.current >= 0 && this.current < this.steps - 1;
    },
    doneBtnShow() {
      return this.current === this.steps - 1;
    },
  },
  methods: {
    clickCanelBtnHandler() {
      let prefix = '';
      switch (this.type) {
        case 'add':
          prefix = '添加大类';
          break;
        case 'update':
          prefix = '添加题目';
          break;
        default:
          break;
      }

      if (window.confirm(`${prefix}未完成，确认返回？`)) {
        this.$emit('canel');
      }
    },
    /**
     * 点击上一步按钮处理函数
     */
    clickPrevBtnHandler() {
      this.prev();
    },
    /**
     * 点击下一步按钮处理函数
     */
    clickNextBtnHandler() {
      this.next();
    },
    /**
     * 点击完成按钮处理函数
     */
    clickDoneBtnHandler() {
      this.$emit('done');
    },
    /**
     * 跳转到上一步
     */
    prev() {
      this.$emit('prev');
    },
    /**
     * 跳转到下一步
     */
    next() {
      this.$emit('next');
    },
  },
};
</script>

<style lang="less" scoped>
.add-question-action-bar {
  display: flex;
  justify-content: center;
  width: 100%;

  > a {
    margin-right: 36px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
